/**
 * 扩展原生方法
 */

/**
 * 扩展Array删除元素
 * @param {(item: T, index: number) => boolean} predicate 为function，根据筛选条件删除
 * @param {S extends T} predicate 为object时，匹配相同元素删除
 * @param {boolean} multiple 是否删除多个元素
 * @returns 数组对象
 */
Array.prototype.remove = function (
  predicate: object | ((item: object, index: number) => boolean),
  multiple?: boolean,
) {
  const isFunc = typeof predicate === 'function';
  if (multiple) {
    // 从后往前遍历，删除元素以后，不影响之后的循环
    for (let i = this.length - 1; i >= 0; i--) {
      if (isFunc ? predicate(this[i], i) : this[i] === predicate) {
        this.splice(i, 1);
      }
    }
  } else {
    // 删除单个元素，从前往后遍历
    for (let j = 0; j < this.length; j++) {
      if (isFunc ? predicate(this[j], j) : this[j] === predicate) {
        this.splice(j, 1);
        break;
      }
    }
  }
  return this;
};
